import { useContext } from 'react';
import { KioskContext } from '../context/kiosk';
import useApi from "./useApi";
import { HotelContext } from '../context/hotel';

export const useKiosk = () => {
    const context = useContext(KioskContext); 
    const { data: hotel } = useContext(HotelContext);
    const { post } = useApi();

    if (!context) {
        throw new Error('useKiosk debe ser usado dentro de KioskProvider');
    }
    
    const loginKiosk = async (password) => {        
        try {
            const response = await post(`hotels/${hotel?.id}/access/pin`, { section: 'kiosk', pin: password });
            if (response && response?.valid == true) {
                context.setLoginKiosk();
                return response
            }
            return null;
        } catch (error) {
            console.error('Error logging in kiosk:', error);
            return null;
        }
    };

    return { 
        isKioskMode: context.isKioskMode,
        isKioskLoggedIn: context.isKioskLoggedIn,
        kioskDomain: context.kioskDomain,
        setLoginKiosk: context.setLoginKiosk,
        setLogoutKiosk: context.setLogoutKiosk,
        lastEvent: context.lastEvent,
        clearLastEvent: context.clearLastEvent,
        isProcessingEvent: context.isProcessingEvent,
        setIsProcessingEvent: context.setIsProcessingEvent,
        loginKiosk 
    };
};

